@import "../../../../../styles/variables.scss";

qds-button {
  left: 56px;
  position: fixed;

  @media (max-width: 1024px) {
    left: 23px;
  }

  @media (max-width: $uiaas-tablet) {
    display: none;
  }
}
